import { Component } from '@angular/core';
import { LoginComponent } from '@angular-monorepo/auth';

@Component({
  selector: 'app-ditrack-login',
  imports: [LoginComponent],
  template: `<lib-login
    overlayClass="bg-black/70"
    headerClass="bg-primary-700 py-3"
    titleClass="text-white"
    subtitleClass="text-white/70"
  />`,
})
export class DitrackLoginComponent {}
